import { gql } from '__generated__';

export default gql(`
  mutation Preregister($input: PreregistrationInput!) {
    preregister(input: $input)
  }
`);
